import React, { useState, useEffect } from 'react';
import { Truck, X } from 'lucide-react';
import './DeliveryNotification.css';

const DeliveryNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300 && !isClosed) {
        setIsVisible(true);
      } else if (window.scrollY <= 300) {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isClosed]);

  const handleClose = () => {
    setIsClosed(true);
    setIsVisible(false);
  };

  return (
    <div className={`delivery-notification ${isVisible ? 'visible' : ''}`}>
      <div className="notification-content">
        <div className="notification-icon">
          <Truck size={24} />
        </div>
        <div className="notification-text">
          <p className="notification-title">Free Delivery</p>
          <p className="notification-subtitle">Available up to 2 miles</p>
        </div>
        <button onClick={handleClose} className="notification-close">
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default DeliveryNotification;